import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../../redux/configureStore';
import { setDocumentDebt } from '../../../../../../../../../redux/fetchActions/legadoPage/transferApp';
import Wrapper from '../../../../../../../../../shared/components/Wrapper';

function SetDocumentDeb() {
  const dispatch = useDispatch();
  const transfersFilterState = useSelector(
    (reducer: IReducer) => reducer.transfersFilterApp
  );

  const handleInputChange = (event) => {
    let { value } = event.target;

    // Remove only mask separators and uppercase, keeping [A-Z0-9] to support
    // alphanumeric CNPJ (letters allowed in the first 12 positions)
    value = value.replace(/[.\-/]/g, '').toUpperCase();

    // Apply CPF or CNPJ mask
    if (value.length <= 11) {
      // CPF mask: 999.999.999-99
      value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else {
      // CNPJ mask: XX.XXX.XXX/XXXX-XX (12 alphanumeric positions + 2 numeric DV)
      value = value.replace(
        /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/,
        '$1.$2.$3/$4-$5'
      );
    }

    if (value.length > 18) {
      dispatch(setDocumentDebt(value.slice(0, 18)));
    } else {
      dispatch(setDocumentDebt(value));
    }
  };

  return (
    <Wrapper.Default
      width="25%"
      style={{ padding: '0 15px 5px' }}
      isActive
      flexDirection="column"
      alignItens="start">
      <span
        style={{ paddingBottom: '5px', fontWeight: 700, lineHeight: '16px' }}>
        CPF/CNPJ:
      </span>
      <Form.Control
        type="text"
        onChange={handleInputChange}
        value={transfersFilterState.debt.cpfcnpj}
      />
    </Wrapper.Default>
  );
}

export default SetDocumentDeb;
